import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=0edb593a"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edb593a')) {
      api.createRecord('0edb593a', component.options)
    } else {
      api.reload('0edb593a', component.options)
    }
    module.hot.accept("./CategoryList.vue?vue&type=template&id=0edb593a", function () {
      api.rerender('0edb593a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/shop/CategoryList.vue"
export default component.exports